import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

import type { SelectedFilterValue } from '../types';

export const UseSpecialCategoryFilterValueFragment = graphql(/* GraphQL */ `
  fragment UseSpecialCategoryFilterValueFragment on SearchProductResult {
    ... on SuccessfulSearchResult {
      selectedCategory {
        id
      }
    }
  }
`);

export const SPECIAL_CATEGORY_FILTER_ID = 'SERP-special-category-filter';

export const useSpecialCategoryFilterValue = (
  maskedData: FragmentType<typeof UseSpecialCategoryFilterValueFragment>,
) => {
  const data = getFragmentData(UseSpecialCategoryFilterValueFragment, maskedData);

  return {
    selectedCategoryFilterValues:
      'selectedCategory' in data && data.selectedCategory
        ? [
            {
              filterId: SPECIAL_CATEGORY_FILTER_ID,
              selectedValues: [data.selectedCategory.id],
            } satisfies SelectedFilterValue,
          ]
        : [],
  };
};
